/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".image-box[_ngcontent-%COMP%]{background:#f6f6f6}.image-box[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
